import { useEffect, useState } from "react";
import * as styled from "./WeekSelector.styled";
import { format } from "date-fns";

function WeekSelector({ weeks, currentWeek, setCurrentWeek }) {
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    // При первой загрузке, если currentWeek не задан, ставим weeks[0]
    if (!currentWeek && weeks.length > 0) {
      setCurrentWeek(weeks[0]);
    }
  }, [weeks, currentWeek, setCurrentWeek]);

  const formatWeekRange = (date) => {
    const start = new Date(date);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    return `${format(start, 'dd.MM')} - ${format(end, 'dd.MM.yyyy')}`;
  };

  return (
    <styled.WeekSelectorContainer>
      <styled.WeekTitle>Тиждень:</styled.WeekTitle>
      <styled.WeeksContainer>
        {weeks.map((week, index) => {
          const isActive = clicked
            ? week.getTime() === currentWeek?.getTime()
            : index === 0;

          return (
            <styled.WeekButton
              key={week.getTime()}
              active={isActive}
              onClick={() => {
                setCurrentWeek(week);
                setClicked(true);
              }}
            >
              {formatWeekRange(week)}
            </styled.WeekButton>
          );
        })}
      </styled.WeeksContainer>
    </styled.WeekSelectorContainer>
  );
}

export default WeekSelector;
